module.exports = __webpack_public_path__ + "static/media/35-10.80b05be4.mp3";